export const Layout = () => import('@/layout/index.vue')
import { getRouteRoles } from '@/utils/index'

/**
 * 设置管理路由
 */
const routes = {
  path: '/setting',
  redirect: 'noRedirect',
  component: Layout,
  meta: {
    icon: 'Setting',
    title: '相关信息配置',
    roles: [],
    activeMenuTop: '/setting',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  },
  children: [
    {
      path: 'setting',
      name: 'SettingSetting',
      component: () => import('@/views/setting/setting/setting.vue'),
      meta: {
        icon: 'Setting',
        title: '网站信息配置',
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'accord',
      name: 'SettingAccord',
      redirect: 'noRedirect',
      meta: {
        icon: 'Document',
        title: '协议管理',
        roles: ['admin/setting.Accord/list'],
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'SettingAccordList',
          component: () => import('@/views/setting/accord/list.vue'),
          meta: {
            icon: 'Document',
            title: '协议管理',
            roles: ['admin/setting.Accord/list'],
            activeMenuTop: '/setting',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'SettingAccordInfo',
          component: () => import('@/views/setting/accord/info.vue'),
          meta: {
            title: '协议信息',
            roles: ['admin/setting.Accord/list'],
            activeMenu: '/setting/accord/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'SettingAccordAdd',
          component: () => import('@/views/setting/accord/add.vue'),
          meta: {
            title: '协议添加',
            roles: ['admin/setting.Accord/list'],
            activeMenu: '/setting/accord/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'SettingLinkInfo',
          component: () => import('@/views/setting/link/info.vue'),
          meta: {
            title: '链接信息',
            roles: ['admin/setting.Link/list'],
            activeMenu: '/setting/link/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'SettingAccordEdit',
          component: () => import('@/views/setting/accord/edit.vue'),
          meta: {
            title: '协议修改',
            roles: ['admin/setting.Accord/list'],
            activeMenu: '/setting/accord/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'link',
      name: 'SettingLink',
      redirect: 'noRedirect',
      meta: {
        icon: 'Link',
        title: '链接管理',
        roles: ['admin/setting.Link/list'],
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'SettingLinkList',
          component: () => import('@/views/setting/link/list.vue'),
          meta: {
            title: '链接管理',
            roles: ['admin/setting.Link/list'],
            activeMenuTop: '/setting',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'SettingLinkInfo',
          component: () => import('@/views/setting/link/info.vue'),
          meta: {
            title: '链接信息',
            roles: ['admin/setting.Link/list'],
            activeMenu: '/setting/link/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'SettingLinkAdd',
          component: () => import('@/views/setting/link/add.vue'),
          meta: {
            title: '链接添加',
            roles: ['admin/setting.Link/list'],
            activeMenu: '/setting/link/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'SettingLinkEdit',
          component: () => import('@/views/setting/link/edit.vue'),
          meta: {
            title: '链接修改',
            roles: ['admin/setting.Link/list'],
            activeMenu: '/setting/accord/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'help-article',
      name: 'SettingHelpArticle',
      redirect: 'noRedirect',
      meta: {
        icon: 'Tickets',
        title: 'PC帮助文档管理',
        roles: ['admin/setting.HelpArticle/list'],
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'SettingHelpArticleList',
          component: () => import('@/views/setting/help-article/list.vue'),
          meta: {
            title: 'PC帮助文档管理',
            roles: ['admin/setting.HelpArticle/list'],
            activeMenuTop: '/setting',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'SettingHelpArticleAdd',
          component: () => import('@/views/setting/help-article/add.vue'),
          meta: {
            title: '帮助文章添加',
            roles: ['admin/setting.HelpArticle/add'],
            activeMenu: '/setting/help-article/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'SettingHelpArticleEdit',
          component: () => import('@/views/setting/help-article/edit.vue'),
          meta: {
            title: '帮助文章修改',
            roles: ['admin/setting.HelpArticle/edit'],
            activeMenu: '/setting/help-article/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'admin/help-article',
      name: 'SettingAdminHelpArticle',
      redirect: 'noRedirect',
      meta: {
        icon: 'Tickets',
        title: 'Admin帮助文档管理',
        roles: ['admin/setting.HelpArticle/list'],
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'SettingAdminHelpArticleList',
          component: () => import('@/views/setting/admin/help-article/list.vue'),
          meta: {
            title: 'Admin帮助文档管理',
            roles: ['admin/setting.HelpArticle/list'],
            activeMenuTop: '/setting',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'article-publish',
      name: 'SettingArticlePublish',
      redirect: 'noRedirect',
      meta: {
        icon: 'EditPen',
        title: '文章发布',
        roles: ['admin/setting.HelpArticle/list'],
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'SettingArticlePublishList',
          component: () => import('@/views/setting/article-publish/list.vue'),
          meta: {
            title: '文章发布',
            roles: ['admin/setting.HelpArticle/list'],
            activeMenuTop: '/setting',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'SettingArticlePublishAdd',
          component: () => import('@/views/setting/article-publish/add.vue'),
          meta: {
            title: '文章发布添加',
            roles: ['admin/setting.HelpArticle/add'],
            activeMenu: '/setting/article-publish/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'SettingArticlePublishEdit',
          component: () => import('@/views/setting/article-publish/edit.vue'),
          meta: {
            title: '文章发布修改',
            roles: ['admin/setting.HelpArticle/edit'],
            activeMenu: '/setting/article-publish/list',
            activeMenuTop: '/setting',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'ai-prompt',
      name: 'SettingAiPrompt',
      component: () => import('@/views/setting/ai-prompt/setting.vue'),
      meta: {
        icon: 'ChatLineRound',
        title: 'AI提示词配置',
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'risk-tip',
      name: 'SettingRiskTip',
      component: () => import('@/views/setting/risk-tip/setting.vue'),
      meta: {
        icon: 'Warning',
        title: '风险提示配置',
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'agent-config',
      name: 'SettingAgentConfig',
      component: () => import('@/views/setting/agent-config/setting.vue'),
      meta: {
        icon: 'UserFilled',
        title: '推广海报配置',
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'bank-config',
      name: 'SettingBankConfig',
      component: () => import('@/views/setting/bank-config/setting.vue'),
      meta: {
        icon: 'CreditCard',
        title: '收款银行配置',
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    }
  ]
}

routes.meta.roles = getRouteRoles(routes)

export default routes
